import { APP_SCREVER } from 'constants/urls';

export const getScreverTemplateEditLink = (TEMPLATE_ID) =>
  // `${APP_SCREVER}?with-template=id-${TEMPLATE_ID}`;
  `${APP_SCREVER}/use-template/${TEMPLATE_ID}`;